
import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, deleteUser } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';
import styles from './hesabim.module.css';
import { doc, getDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import icon from '../images/icons/svg_380550.svg';

const Hesabim = () => {
    const [user, setUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [message2, setMessage2] = useState('');
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [message3, setMessage3] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                setUser(firebaseUser);
                const docRef = doc(db, 'users', firebaseUser.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    setUserData(docSnap.data());
                }
            } else {
                navigate('/giris');
            }
        });
        return () => unsubscribe();
    }, [navigate]);

    const handleLogout = async () => {
        try {
            await auth.signOut();
            localStorage.removeItem('token');
            setMessage2('Başarılı bir şekilde çıkış yapıldı.');
        } catch (error) {
            console.error('Logout Error:', error);
        }
    };

    const handleDeleteAccount = async () => {
        try {
            if (user) {
                // Firestore'daki kullanıcıyı sil
                const userDocRef = doc(db, 'users', user.uid);
                await deleteDoc(userDocRef);

                // Authentication'dan kullanıcıyı sil
                await deleteUser(user);

                setMessage3('Hesabınız başarıyla silindi.');
                setTimeout(() => {
                    navigate('/giris');  // Silme işleminden sonra giriş sayfasına yönlendir
                }, 2000);
            }
        } catch (error) {
            console.error('Hesap Silme Hatası:', error);
        }
    };

    if (!user) {
        return null; // Kullanıcı yüklenene kadar bir şey gösterme
    }

    return (    
        <main className={styles.main}>
            <section className={styles.section}>
                <div>
                    <h1 className={styles.header}>Hoş Geldiniz, {userData?.firstName} {userData?.lastName}</h1>
                    
                    <section className={styles.infoSection}>
                        <h2>Bilgilerim</h2>
                        
                            {userData?.isreederimuser && (
                                <div className={styles.iconcontainer}>
                                    <img className={styles.icon} src={icon} alt="asdf" width="100" height="100" />
                                    <span className={styles.tooltip}>Reeder kullanıcısısınız</span>
                                </div>
                            )}
                        <ul className={styles.infoList}>
                            <li><span className={styles.infoLabel}>Ad:</span> {userData?.firstName}</li>
                            <li><span className={styles.infoLabel}>Soyad:</span> {userData?.lastName}</li>
                            <li><span className={styles.infoLabel}>Email:</span> {user.email}</li>
                            <li><span className={styles.infoLabel}>Doğum Tarihi:</span> {userData?.birthDate}</li>
                            <li><span className={styles.infoLabel}>Telefon Numarası:</span> {userData?.phone}</li>
                        </ul>
                    </section>
                </div>
                <button onClick={handleLogout} className={styles.button}>Çıkış Yap</button>
                {message2 && <p className={styles.successMessage}>{message2}</p>}
                
                <button onClick={() => setShowDeleteConfirm(true)} className={styles.deleteButton}>Hesabı Sil</button>
                {showDeleteConfirm && (
                    <>
                        <div className={styles.overlay} />
                        <div className={styles.confirmPopup}>
                            <p>Hesabınızın silinmesini onaylıyor musunuz?</p>
                            <button onClick={handleDeleteAccount} className={styles.confirmButton}>Evet</button>
                            <button onClick={() => setShowDeleteConfirm(false)} className={styles.cancelButton}>Hayır</button>
                        </div>
                    </>
                )}
                {message3 && <p className={styles.successMessage}>{message3}</p>}
            </section>
        </main>
    );
}

export default Hesabim;
